<template>
  <filters-button
    class="filters-time-range"
    :icon="info.icon"
    :text="info.title"
    :sub_text="`(${time_start} - ${time_end})`"
    :active="current_filter === filter_id"
    @click="handle_filter_click"
  >
  </filters-button>
</template>

<script>
import FiltersButton from "./filters-button.vue";
import { time_ranges } from "@liveflight/resources/filters";
import { time_format } from "@liveflight/utilities/filters";

export default {
  name: "filters-time-range",
  components: {
    "filters-button": FiltersButton,
  },
  props: {
    filter_id: {
      type: String,
      required: true,
    },
    set_time_range_filter: {
      type: Function,
      required: true,
    },
    current_filter: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      time_ranges,
    };
  },
  methods: {
    time_format,
    handle_filter_click() {
      this.set_time_range_filter(
        this.current_filter !== this.filter_id ? this.filter_id : "",
      );
    },
  },
  computed: {
    info() {
      return this.time_ranges[this.filter_id];
    },
    time_start() {
      return this.time_format(this.info.time_start);
    },
    time_end() {
      return this.time_format(this.info.time_end);
    },
  },
};
</script>
